import React from 'react';
import { Outlet } from 'react-router-dom';
import Contact from '../Components/Contact';
import Header from '../Components/Header';

const Main = () => {
    return (
        <div>
          <Header />
          <Outlet />
          
        </div>
    );
};

export default Main;   